import React, { Component, createRef } from "react";
import { ReCaptcha } from "react-recaptcha-v3";
import { InputElement } from "../../UI";
import { SingleOrCoApp } from "../Steps";
import stepHandler from "../StepHandler";
import { validators } from "../../../utility/forms";
import { RiLock2Line } from "react-icons/ri";
import { FiEye, FiEyeOff } from "react-icons/fi";

import {
	Button,
	Container,
	Center,
	Flex,
	Heading,
	Box,
	Text,
	SimpleGrid,
	Separator,
	FieldRoot,
	InputGroup,
	HStack,
	Spacer,
} from "@chakra-ui/react";
const trackedFields = [
	"firstName",
	"lastName",
	"suffix",
	"street1",
	"street2",
	"city",
	"state",
	"zipCode",
	"ssn",
	"dateOfBirth",
	"email",
	"phone",
];

class AboutYou extends Component {
	constructor() {
		super();
		
	}
	cityRef = createRef();
	streetRef = createRef();

	previousZoneStyles = null;

	state = {
    loading: false,
    hidden: true,
    url: process.env.REACT_APP_WEBSITE_URL,
    recaptchaInit: false,
    recaptchaVerified: false,
};

	componentDidMount() {
    this.props.trackFields("About You", trackedFields);
    window.scrollTo(0, 0);
    setTimeout(() => {
        document.getElementById("ssn").type = "password";
    }, 100);
}

	toggleHidden = () => {
    this.setState({ hidden: !this.state.hidden }, () => {
        const input = document.getElementById("ssn");
        if (input) {
            input.type = this.state.hidden ? "password" : "text";
        }
    });
};

	render() {
		const nextButton = document.getElementById("next-button");

		const hasValidNames =
			validators.hasValue(this.props.form.lastName.value) &&
			validators.hasValue(this.props.form.firstName.value);
		const hasValidDob =
			this.props.form.dateOfBirth.value &&
			validators.validateMinimumAge(
				this.props.form.dateOfBirth.value,
				this.props.config.minimumAge,
			).isValid;

		//Check for on-screen errors
		let validCheck = false;
		let errors = document.getElementsByClassName("red");
		if (errors.length === 0) {
			validCheck = true;
		} else {
			validCheck = false;
		}

		//Form "Next" validation check
		nextButton.disabled = true;
		if (
			/^\d{3}-\d{2}-\d{4}$/.test(this.props.form.ssn.value) &&
			/^(([^<>()[\]\.,;:\s@\"+]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(
				this.props.form.email.value,
			) &&
			/^\(\d{3}\)\s\d{3}-\d{4}/.test(this.props.form.phone.value) &&
			hasValidNames &&
			/^\d{5}$/.test(this.props.form.zipCode.value) &&
			this.props.form.street1.value !== "" &&
			this.props.form.city.value !== "" &&
			this.props.form.state.value !== "" &&
			this.props.form.singleOrCoApp.value !== "" &&
			hasValidDob
		) {
			nextButton.disabled = false;
		}

		return (
			<Box mt={10} mb={20}>
				<Center>
					<Box maxW="510px">
						<Center>
                    <Heading style={{ fontSize: "16px", fontWeight: "bold" }} mb={14}>
						Let's get some information about you
					</Heading>
						</Center>

						<Text fontSize="18px" as="b">
							ABOUT YOU
						</Text>
						<FieldRoot mt={10}>
							<SimpleGrid columns={{ sm: 1, md: 3 }} gap={{ sm: 0, md: 5 }}>
								<Box>
									<InputElement
										formElement={this.props.form.firstName}
										onChange={(event) =>
											this.props.onChanged(event, "firstName")
										}
										onBlur={(event) => this.props.onBlurred(event, "firstName")}
									/>
								</Box>
								<Box>
									<InputElement
										formElement={this.props.form.lastName}
										onChange={(event) =>
											this.props.onChanged(event, "lastName")
										}
										onBlur={(event) => this.props.onBlurred(event, "lastName")}
									/>
								</Box>

								<Box>
									<InputElement
										formElement={this.props.form.suffix}
										onChange={(event) => this.props.onChanged(event, "suffix")}
										onBlur={(event) => this.props.onBlurred(event, "suffix")}
									/>
								</Box>
							</SimpleGrid>
							<Text mt={2} color="#777777">
								Enter your name as it appears on your state or US
								government-issued ID.
							</Text>

							<Box mt={6} maxWidth={250}>
								<InputElement
									formElement={this.props.form.email}
									onChange={(event) => this.props.onChanged(event, "email")}
									onBlur={(event) => this.props.onBlurred(event, "email")}
								/>
							</Box>
							<Box maxWidth={250} mt={5}>
								{" "}
								<InputElement
									formElement={this.props.form.phone}
									onChange={(event) => this.props.onChanged(event, "phone")}
									onBlur={(event) => this.props.onBlurred(event, "phone")}
								/>
							</Box>
							<Text mt={2} color="#777777">
								You can choose your communication preferences later.
							</Text>
							<Box mt={6} maxWidth={250}>
								<InputElement
									formElement={this.props.form.dateOfBirth}
									onChange={(event) =>
										this.props.onChanged(event, "dateOfBirth")
									}
									onBlur={(event) => this.props.onBlurred(event, "dateOfBirth")}
								/>
							</Box>

							<Container mt={25} mb={25} maxW="510px" bg="#F5F5F5" p={6}>
								<Box p={5}>
									<Text fontSize="sm">
										We’ll use this to verify your identity and determine your
										offer. Remember, this{" "}
										<span style={{ fontWeight: "bold" }}>
											doesn’t impact your credit score!
										</span>
									</Text>
									<Text fontSize="sm" mb={3} mt={4}>
										Social Security Number
									</Text>
									<Box position="relative" >
								<Box className={this.state.hidden ? "ssn-hidden" : ""}>
									<InputElement
										formElement={this.props.form.ssn}
										onChange={(event) =>
											this.props.onChanged(event, "ssn")
										}
										onBlur={(event) => this.props.onBlurred(event, "ssn")}
									/>
								</Box>
								<Box
								position="absolute"
								right="10px"
								top="10px"
								onClick={this.toggleHidden}
								style={{ cursor: "pointer" }}
							>
									{this.state.hidden ? <FiEyeOff size={20} /> : <FiEye size={20} />}
								</Box>
							</Box>

										<Box borderTop="1px solid #ccc" style={{ marginTop: "30px" }} />
								<Box style={{ marginTop: "10px" }}>
									<HStack gap={2}>
										<RiLock2Line />
										<Text fontSize="sm" style={{ marginTop: "19px" }}>
									Your information is safe and secure
								</Text>
									</HStack>
								</Box>
								</Box>
							</Container>
							<Text fontSize="18px" as="b">
								YOUR MAILING ADDRESS
							</Text>
							<SimpleGrid
								mt={14}
								columns={{ sm: 1, md: 2 }}
								gap={{ sm: 20, md: 40 }}
							>
								<Box minW={300}>
									<InputElement
										domRef={this.streetRef}
										formElement={this.props.form.street1}
										onChange={(event) => this.props.onChanged(event, "street1")}
										onBlur={(event) => this.props.onBlurred(event, "street1")}
									/>
								</Box>
								<Box>
									<InputElement
										formElement={this.props.form.street2}
										onChange={(event) => this.props.onChanged(event, "street2")}
										onBlur={(event) => this.props.onBlurred(event, "street2")}
									/>
								</Box>
							</SimpleGrid>
							<SimpleGrid columns={{ sm: 1, md: 3 }} gap={5} mt={5}>
								<Box>
									<InputElement
										domRef={this.cityRef}
										formElement={this.props.form.city}
										onChange={(event) => this.props.onChanged(event, "city")}
										onBlur={(event) => this.props.onBlurred(event, "city")}
									/>
								</Box>
								<Box>
									<InputElement
										readOnly
										formElement={this.props.form.state}
										onChange={(event) => this.props.onChanged(event, "state")}
										onBlur={(event) => this.props.onBlurred(event, "state")}
									/>
								</Box>

								<Box>
							<InputElement
								className="zip"
								readOnly
								formElement={this.props.form.zipCode}
								onChange={(event) => this.props.onChanged(event, "zipCode")}
								onBlur={(event) => this.props.onBlurred(event, "zipCode")}
							/>
						</Box>
						</SimpleGrid>
						</FieldRoot>

						<ReCaptcha
							sitekey={process.env.REACT_APP_RECAPTCHA_SITE}
							action="aboutLoad"
							size="invisible"
							verifyCallback={this.verifyCallback}
						/>
						<SingleOrCoApp {...this.props} />
						<Box m={5} borderTop="1px solid #ccc" />
					</Box>
				</Center>
				<Container maxWidth={"510px"}>
					<Flex>
						<Button
							id="back-button"
							onClick={() => {
								this.props.save();
								this.props.previous();
							}}
							bg="white"
							color="#2371a5"
							_hover={{ bg: "#3c99d3", color: "white" }}
							size="lg"
							border="1px solid #2371a5"
							borderRadius="6px"
							mt={10}
							p={4}
						>
							Back
						</Button>
						<Spacer />
						<Button
							id="next-button"
							onClick={() => {
								this.props.next();
								this.setState({ loading: true });
							}}
							loading={this.state.loading}
							loadingText="Continue"
							borderRadius="6px"
							bg="#2371a5"
							color="white"
							_hover={{ bg: "#3c99d3" }}
							size="lg"
							mt={10}
							p={4}
						>
							Continue
						</Button>{" "}
					</Flex>
				</Container>
			</Box>
		);
	}
}

export default stepHandler(AboutYou);
